import React, { ReactNode } from 'react';

import * as Styled from 'shiftNotes/styles/InstantReflex/ReflexStepCard.style';

export interface ReflexStepCardProps {
  label: string;
  labelColor: string;
  icon: ReactNode;
  title: string;
  children?: ReactNode;
}

export default function ReflexStepCard({
  label,
  labelColor,
  icon,
  title,
  children,
}: ReflexStepCardProps): JSX.Element {
  return (
    <Styled.Card>
      <Styled.LabelRow>
        <Styled.LabelIcon $color={labelColor}>{icon}</Styled.LabelIcon>
        <Styled.LabelText $color={labelColor}>{label}</Styled.LabelText>
      </Styled.LabelRow>
      <Styled.Title>{title}</Styled.Title>
      {children}
    </Styled.Card>
  );
}
